import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"

import ImageUploader from "react-images-upload"
import LinearProgress from "@material-ui/core/LinearProgress"
import { Lightbox } from "react-modal-image"
import { Multiselect } from "multiselect-react-dropdown"

const styleselect = {
      multiselectContainer: {
            // To change css for multiselect (Width,height,etc..)
            fontSize: "14px",
            border: "1.25px solid #bababa",
            borderRadius: "4px",
      },
      searchBox: {
            // To change search box element look
            fontSize: "14px",
            minheight: "50px",
            textAlign: "right",
      },
      inputField: {
            // To change input field position or margin
            margin: "5px",
            fontSize: "14px",
      },
      chips: {
            // To change css chips(Selected options)
            //  background: '#00000000',
            border: "2px solid",
            fontSize: "14px",
      },
      optionContainer: {
            // To change css for option container
            textAlign: "right",
      },
      option: {
            // To change css for dropdown options
            fontSize: "14px",
            textAlign: "right",
      },
      groupHeading: {
            // To chanage group heading style
      },
}

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ChangeFieldInsurance extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  fieldinsurance_id: "",
                  fieldinsurance: "",
                  fieldinsurance_fa: "",
                  fieldinsurance_link: "",
                  fieldinsurance_commission: "",
                  fieldinsurance_priority: "",
                  selectedFildInsuranceGroup: "",
                  optionFildInsuranceGroup: [],
                  fieldinsurance_badge: "",
                  fieldinsurance_desc: "",
                  fieldinsurance_api_price: "",
                  fieldinsurance_perentlink: "",
                  fieldinsurance_mode: "1",
                  fieldinsurance_deactive: "1",
                  fieldinsurance_logo_url: "",
                  fieldinsurance_timage: "",
                  fieldinsurance_image: "",
                  orderBy: "fieldinsurance_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newFildInsurance: true,
                  logoFildInsurance: "",
                  imageFildInsurance: "",
                  loading: false,
                  percent: 0,

                  urlToLargeImageFile: "",
                  urlToHugeImageFile: "",
                  descImageFile: "",
                  openImageBox: false,
            }
      }

      setImageModel = (image, largimage, desc) => {
            this.setState({
                  urlToLargeImageFile: largimage,
                  urlToHugeImageFile: image,
                  descImageFile: desc,
                  openImageBox: true,
            })
      }

      closeLightbox = () => {
            this.setState({
                  openImageBox: false,
            })
      }

      handleFildInsuranceGroup = (selectedFildInsuranceGroup) => {
            this.setState({ selectedFildInsuranceGroup: selectedFildInsuranceGroup })
      }




      handleChangeFieldInsuranceName = (event) => {
            this.setState({ fieldinsurance: event.target.value })
      }
      handleChangeFieldInsuranceId = (event) => {
            this.setState({ fieldinsurance_id: event.target.value })
      }

      onSelectLogoFildInsurance = (picture) => {
            this.setState({
                  logoFildInsurance: picture[0],
            })
      }

      onSelectImageFildInsurance = (picture) => {
            this.setState({
                  imageFildInsurance: picture[0],
            })
      }

      handleChangeFieldInsuranceBadge = (event) => {
            this.setState({ fieldinsurance_badge: event.target.value })
      }

      handleChangeFieldInsuranceGroup1 = (event) => {
            this.setState({ fieldinsurance_perentlink: event.target.value })
      }




      handleChangeFieldInsuranceDesc = (event) => {
            this.setState({ fieldinsurance_desc: event.target.value })
      }

      handleChangeFieldInsuranceApi = (event) => {
            this.setState({ fieldinsurance_api_price: event.target.value })
      }


      handleLevelof_prosperity = (event) => {
            this.setState({ fieldinsurance_fa: event.target.value })
      }

      handleTimeanswer_complaints = (event) => {
            this.setState({ fieldinsurance_link: event.target.value })
      }

      handleCommission = (event) => {
            this.setState({ fieldinsurance_commission: event.target.value })
      }

      handlePriority = (event) => {
            this.setState({ fieldinsurance_priority: event.target.value })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeDeactive = (event) => {
            if (event.target.checked) {
                  this.setState({ fieldinsurance_deactive: "0" })
            } else {
                  this.setState({ fieldinsurance_deactive: "1" })
            }
      }

      handleChangeMode = (event) => {
            if (event.target.checked) {
                  this.setState({ fieldinsurance_mode: "0" })
            } else {
                  this.setState({ fieldinsurance_mode: "1" })
            }
      }

      handleCalculate = (selectedCalculate) => {
            this.setState({ selectedCalculate: selectedCalculate })
      }

      handleSelectRows = (row2) => {
        console.log(row2.fieldinsurance_fieldinsurance_groups_id);
        console.log(JSON.parse(row2.fieldinsurance_fieldinsurance_groups_id));
            this.setState(
                  {
                        fieldinsurance_id: row2.fieldinsurance_id,
                        fieldinsurance: row2.fieldinsurance,
                        fieldinsurance_fa: row2.fieldinsurance_fa,
                        fieldinsurance_link: row2.fieldinsurance_link,
                        fieldinsurance_commission: row2.fieldinsurance_commission,
                        fieldinsurance_priority: row2.fieldinsurance_priority,
                        selectedFildInsuranceGroup: JSON.parse(row2.fieldinsurance_fieldinsurance_groups_id),
                        fieldinsurance_badge: row2.fieldinsurance_badge,
                        fieldinsurance_api_price: row2.fieldinsurance_api_price,
                        fieldinsurance_desc: row2.fieldinsurance_desc,
                        fieldinsurance_perentlink: row2.fieldinsurance_perentlink,
                          fieldinsurance_mode: row2.fieldinsurance_mode,
                        fieldinsurance_deactive: row2.fieldinsurance_deactive,
                        fieldinsurance_logo_url: row2.fieldinsurance_logo_url,
                        fieldinsurance_timage: row2.fieldinsurance_timage,
                        fieldinsurance_image: row2.fieldinsurance_image,
                        newFildInsurance: false,
                  },
                  () => {}
            )
      }

      newFildInsurance = (event) => {
            this.setState({
                  fieldinsurance_id: "",
                  fieldinsurance: "",
                  fieldinsurance_fa: "",
                  fieldinsurance_link: "",
                  fieldinsurance_commission: "",
                  fieldinsurance_priority: "",
                  fieldinsurance_badge: "",
                  fieldinsurance_desc: "",
                  fieldinsurance_api_price: "",
                  fieldinsurance_perentlink: "",
                  fieldinsurance_mode: "0",
                  fieldinsurance_deactive: "0",
                  fieldinsurance_logo_url: "",
                  fieldinsurance_timage: "",
                  fieldinsurance_image: "",
                    selectedFildInsuranceGroup: [],
                  newFildInsurance: true,
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.getFildInsurance()
                                    self.getoptionFildInsuranceGroup()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getFildInsurance() {
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {})
                        } else if (arr.result === "error") {
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fieldinsurance")

            xhttp.open("POST", `${constants.BASE_URL}/fieldinsurance`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getoptionFildInsuranceGroup = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var FildInsuranceGroup = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    FildInsuranceGroup.push({ fieldinsurance_groups_id: arr.data[k].fieldinsurance_groups_id, fieldinsurance_name_fa: arr.data[k].fieldinsurance_name_fa, fieldinsurance_name_en: arr.data[k].fieldinsurance_name_en })
                              }
                              self.setState({ optionFildInsuranceGroup: FildInsuranceGroup }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fieldinsurance_groups")
            xhttp.open("POST", `${constants.BASE_URL}/fieldinsurance`)
            xhttp.send(fd)
      }

      saveNewFildInsurance = (logoCode, imageCode) => {
            const {
                  fieldinsurance_id,
                  fieldinsurance,
                  fieldinsurance_fa,
                  fieldinsurance_link,
                  fieldinsurance_priority,
                  fieldinsurance_commission,
                  fieldinsurance_badge,
                  fieldinsurance_api_price,
                  fieldinsurance_desc,
                  selectedFildInsuranceGroup,
                  fieldinsurance_perentlink,
                  fieldinsurance_mode,
                  fieldinsurance_deactive,
            } = this.state
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getFildInsurance()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "add_fieldinsurance")
            fd.append("fieldinsurance_id", fieldinsurance_id)
            fd.append("fieldinsurance", fieldinsurance)
            fd.append("fieldinsurance_fa", fieldinsurance_fa)
            fd.append("fieldinsurance_link", fieldinsurance_link)
            fd.append("fieldinsurance_commission", fieldinsurance_commission)
            fd.append("fieldinsurance_priority", fieldinsurance_priority)
            fd.append("fieldinsurance_badge", fieldinsurance_badge)
            fd.append("fieldinsurance_desc", fieldinsurance_desc)
            fd.append("fieldinsurance_api_price", fieldinsurance_api_price)
            fd.append("fieldinsurance_perentlink", fieldinsurance_perentlink)
            fd.append("fieldinsurance_logo_code", logoCode)
            fd.append("fieldinsurance_image_code", imageCode)
            fd.append("fieldinsurance_deactive", fieldinsurance_deactive)
            fd.append("fieldinsurance_mode", fieldinsurance_mode)
            fd.append("fieldinsurance_fieldinsurance_groups_id", JSON.stringify(selectedFildInsuranceGroup))
            console.log("logoCode" + logoCode)
            console.log("imageCode" + imageCode)
            xhttp.open("POST", `${constants.BASE_URL}/fieldinsurance`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      changeFildInsurance = (logoCode, imageCode) => {
            const {
                  fieldinsurance_id,
                  fieldinsurance,
                  fieldinsurance_fa,
                  fieldinsurance_link,
                  fieldinsurance_commission,
                  fieldinsurance_priority,
                  fieldinsurance_badge,
                  fieldinsurance_desc,
                  fieldinsurance_api_price,
                  fieldinsurance_perentlink,
                  selectedFildInsuranceGroup,
                  fieldinsurance_mode,
                  fieldinsurance_deactive,
            } = this.state
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getFildInsurance()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_fieldinsurance")
            fd.append("fieldinsurance_id", fieldinsurance_id)
            fd.append("fieldinsurance", fieldinsurance)
            fd.append("fieldinsurance_fa", fieldinsurance_fa)
            fd.append("fieldinsurance_link", fieldinsurance_link)
            fd.append("fieldinsurance_commission", fieldinsurance_commission)
            fd.append("fieldinsurance_priority", fieldinsurance_priority)
            fd.append("fieldinsurance_badge", fieldinsurance_badge)
            fd.append("fieldinsurance_desc", fieldinsurance_desc)
            fd.append("fieldinsurance_api_price", fieldinsurance_api_price)
            fd.append("fieldinsurance_perentlink", fieldinsurance_perentlink)
            fd.append("fieldinsurance_mode", fieldinsurance_mode)
            fd.append("fieldinsurance_deactive", fieldinsurance_deactive)
            fd.append("fieldinsurance_fieldinsurance_groups_id", JSON.stringify(selectedFildInsuranceGroup))
            if (imageCode !== "") {
                  fd.append("fieldinsurance_image_code", imageCode)
            }
            if (logoCode !== "") {
                  fd.append("fieldinsurance_logo_code", logoCode)
            }

            xhttp.open("POST", `${constants.BASE_URL}/fieldinsurance`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      uploadImageFildInsurance = (mode, logoFildInsuranceCode) => {
            const { imageFildInsurance, fieldinsurance_fa } = this.state
            if (imageFildInsurance && imageFildInsurance !== "" && imageFildInsurance !== null) {
                  this.setState({
                        loading: true,
                        percent: 0,
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({
                                          loading: false,
                                          percent: 0,
                                    })
                                    if (mode === "new") {
                                          self.saveNewFildInsurance(logoFildInsuranceCode, arr.data["image_code"])
                                    } else {
                                          self.changeFildInsurance(logoFildInsuranceCode, arr.data["image_code"])
                                    }
                              } else if (arr.result === "error") {
                              }
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "uploadpic")
                  fd.append("image", imageFildInsurance)
                  fd.append("image_name", " تصویر رشته " + fieldinsurance_fa)
                  fd.append("image_desc", "تصویر رشته " + fieldinsurance_fa)
                  fd.append("name", "")
                  xhttp.upload.addEventListener(
                        "progress",
                        function(evt) {
                              if (evt.lengthComputable) {
                                    var percentComplete = evt.loaded / evt.total
                                    self.setState({
                                          percent: percentComplete * 100,
                                    })
                              }
                        },
                        false
                  )
                  xhttp.open("POST", `${constants.BASE_URL}/image`)
                  xhttp.send(fd)
            } else {
                  if (mode === "new") {
                        this.saveNewFildInsurance(logoFildInsuranceCode, "")
                  } else {
                        this.changeFildInsurance(logoFildInsuranceCode, "")
                  }
            }
      }

      uploadPicDelivery = (mode) => {
            const {
                  fieldinsurance_id,
                  fieldinsurance,
                  fieldinsurance_fa,
                  fieldinsurance_link,
                  fieldinsurance_commission,
                  fieldinsurance_priority,
                  fieldinsurance_badge,
                  fieldinsurance_desc,
                  fieldinsurance_api_price,
                  fieldinsurance_perentlink,
                  fieldinsurance_deactive,
                  fieldinsurance_mode,
            } = this.state
            const { logoFildInsurance } = this.state
            if (
                  fieldinsurance_id != "" &&
                  fieldinsurance != "" &&
                  fieldinsurance_fa != "" &&
                  fieldinsurance_fa != "" &&
                  fieldinsurance != "" &&
                  fieldinsurance != ""
            ) {
                  if (logoFildInsurance && logoFildInsurance !== "" && logoFildInsurance !== null) {
                        this.setState({
                              loading: true,
                              percent: 0,
                        })

                        var self = this
                        var xhttp = new XMLHttpRequest()
                        xhttp.onreadystatechange = function() {
                              if (this.readyState === 4 && this.status === 200) {
                                    var arr = JSON.parse(this.responseText)
                                    console.log(arr)
                                    if (arr.result === "ok") {
                                          self.setState({
                                                loading: false,
                                                percent: 0,
                                          })
                                          self.uploadImageFildInsurance(mode, arr.data["image_code"])
                                    } else if (arr.result === "error") {
                                    }
                              }
                        }
                        var fd = new FormData()
                        fd.append("command", "uploadpic")
                        fd.append("image", logoFildInsurance)
                        fd.append("image_name", " لوگوی رشته  " + fieldinsurance_fa)
                        fd.append("image_desc", "لوگوی رشته " + fieldinsurance_fa)
                        fd.append("name", "")
                        xhttp.upload.addEventListener(
                              "progress",
                              function(evt) {
                                    if (evt.lengthComputable) {
                                          var percentComplete = evt.loaded / evt.total
                                          self.setState({
                                                percent: percentComplete * 100,
                                          })
                                    }
                              },
                              false
                        )
                        xhttp.open("POST", `${constants.BASE_URL}/image`)
                        xhttp.send(fd)
                  } else {
                        this.uploadImageFildInsurance(mode, "")
                  }
            } else {
                  this.setState({ snackstr: "لطفا مشخصات شرکت را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }

      onSelectOptionFildInsuranceGroup = (selectedList, selectedItem) => {
            console.log(selectedList)
            this.setState(
                  {
                        selectedFildInsuranceGroup: selectedList,
                  },
                  () => {}
            )
            console.log(JSON.stringify(selectedList))
      }

      onRemoveOptionFildInsuranceGroup = (selectedList, removedItem) => {
            this.setState(
                  {
                        selectedFildInsuranceGroup: selectedList,
                  },
                  () => {}
            )
            console.log(JSON.stringify(selectedList))
      }


      render() {
            const { classes } = this.props
            const {
                  urlToHugeImageFile,
                  descImageFile,
                  urlToLargeImageFile,
                  fieldinsurance_fa,
                  loading,
                  percent,
                  fieldinsurance_link,
                  fieldinsurance_commission,
                  fieldinsurance_priority,
                  agentPermision,
                  snackMode,
                  snackstr,
                  showSnack,
                  newFildInsurance,
                  fieldinsurance_id,
                  fieldinsurance,
                  fieldinsurance_logo_url,
                  fieldinsurance_timage,
                  fieldinsurance_image,
                  fieldinsurance_badge,
                  fieldinsurance_desc,
                  fieldinsurance_api_price,
                  fieldinsurance_perentlink,
                  fieldinsurance_mode,
                  fieldinsurance_deactive,
                    selectedFildInsuranceGroup,
                      optionFildInsuranceGroup,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <img alt="" className={classes.large} src={fieldinsurance_logo_url} />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <img
                                                                              alt=""
                                                                              className={classes.large}
                                                                              src={fieldinsurance_timage}
                                                                              onClick={() => {
                                                                                    this.setImageModel(
                                                                                          fieldinsurance_timage,
                                                                                          fieldinsurance_image,
                                                                                          fieldinsurance_fa
                                                                                    )
                                                                              }}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <Typography align="center" variant="h7">
                                                                        <FloatingLabelInput
                                                                              placeholder="آی دی رشته بیمه"
                                                                              handleInputt={this.handleChangeFieldInsuranceId}
                                                                              value={fieldinsurance_id}
                                                                        />
                                                                  </Typography>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="نامک رشته"
                                                                        handleInputt={this.handleChangeFieldInsuranceName}
                                                                        value={fieldinsurance}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="نام فارسی رشته"
                                                                        handleInputt={this.handleLevelof_prosperity}
                                                                        value={fieldinsurance_fa}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <Multiselect
                                                                        style={styleselect}
                                                                        options={this.state.optionFildInsuranceGroup} // Options to display in the dropdown
                                                                        selectedValues={this.state.selectedFildInsuranceGroup} // Preselected value to persist in dropdown
                                                                        onSelect={this.onSelectOptionFildInsuranceGroup} // Function will trigger on select event
                                                                        onRemove={this.onRemoveOptionFildInsuranceGroup} // Function will trigger on remove event
                                                                        displayValue="fieldinsurance_name_fa" // Property name to display in the dropdown options
                                                                        placeholder="انتخاب گروه"
                                                                        closeIcon="circle2"
                                                                        emptyRecordMsg="فیلد  در دسترس نیست "
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="لینک خارجی "
                                                                        handleInputt={this.handleTimeanswer_complaints}
                                                                        value={fieldinsurance_link}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="درصد کارمزد"
                                                                        handleInputt={this.handleCommission}
                                                                        value={fieldinsurance_commission}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                      placeholder="اولویت رشته "
                                                                      handleInputt={this.handlePriority}
                                                                      value={fieldinsurance_priority}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="لیبل رشته بیمه"
                                                                        handleInputt={this.handleChangeFieldInsuranceBadge}
                                                                        value={fieldinsurance_badge}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="parent_link"
                                                                        handleInputt={this.handleChangeFieldInsuranceGroup1}
                                                                        value={fieldinsurance_perentlink}
                                                                  />
                                                            </Grid>



                                                            <Grid item xs={12}>
                                                                  <FloatingLabelInput
                                                                        placeholder="توضیحات"
                                                                        handleInputt={this.handleChangeFieldInsuranceDesc}
                                                                        value={fieldinsurance_desc}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <FloatingLabelInput
                                                                        placeholder="وب سرویس قیمت دهی"
                                                                        handleInputt={this.handleChangeFieldInsuranceApi}
                                                                        value={fieldinsurance_api_price}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <FormControlLabel
                                                                              control={
                                                                                    <Switch
                                                                                          checked={fieldinsurance_mode === "0" ? true : false}
                                                                                          onChange={this.handleChangeMode}
                                                                                          name="gilad"
                                                                                    />
                                                                              }
                                                                              label="وضعیت آنلاین بودن رشته"
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <FormControlLabel
                                                                              control={
                                                                                    <Switch
                                                                                          checked={fieldinsurance_deactive === "0" ? true : false}
                                                                                          onChange={this.handleChangeDeactive}
                                                                                          name="gilad"
                                                                                    />
                                                                              }
                                                                              label="وضعیت رشته بیمه"
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={3}>
                                                                  <ImageUploader
                                                                        withIcon={true}
                                                                        buttonText="لوگوی رشته را انتخاب نمایید"
                                                                        onChange={this.onSelectLogoFildInsurance}
                                                                        withPreview="true"
                                                                        singleImage="true"
                                                                        imgExtension={[".jpg", ".jpeg", ".gif", ".png", ".gif", ".svg", ".tiff", ".webp", ".Lottie"]}
                                                                        maxFileSize={5242880}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={3}>
                                                                  <ImageUploader
                                                                        withIcon={true}
                                                                        buttonText="تصویر رشته را انتخاب نمایید"
                                                                        onChange={this.onSelectImageFildInsurance}
                                                                        withPreview="true"
                                                                        singleImage="true"
                                                                        imgExtension={[".jpg", ".jpeg", ".gif", ".png", ".gif", ".svg", ".tiff", ".webp", ".Lottie"]}
                                                                        maxFileSize={5242880}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                  {loading && <LinearProgress variant="determinate" value={percent} />}
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  {newFildInsurance ? (
                                                                        <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={(e) => {
                                                                                    this.uploadPicDelivery("new")
                                                                              }}
                                                                        >
                                                                              {"ثبت رشته جدید "}
                                                                        </Button>
                                                                  ) : (
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Button variant="outlined" color="primary" onClick={this.newFildInsurance}>
                                                                                    {"رشته جدید"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.uploadPicDelivery("modify")
                                                                                    }}
                                                                              >
                                                                                    {"ثبت تغییرات"}
                                                                              </Button>
                                                                        </div>
                                                                  )}
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <Divider />
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>
                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell></TableCell>

                                                                              <TableCell
                                                                                    key={"fieldinsurance_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "fieldinsurance_id" ? order : false}
                                                                              >
                                                                                    {"آیدی رشته "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "fieldinsurance_id"}
                                                                                          direction={orderBy === "fieldinsurance_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("fieldinsurance_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"fieldinsurance"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"نام رشته"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "fieldinsurance_fa"}
                                                                                          direction={orderBy === "fieldinsurance_fa" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("fieldinsurance_fa")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"fieldinsurance_commission"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"درصد کارمزد"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "fieldinsurance_commission"}
                                                                                          direction={
                                                                                                orderBy === "fieldinsurance_commission"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("fieldinsurance_commission")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>


                                                                              <TableCell
                                                                                  key={"fieldinsurance_priority"}
                                                                                  align={"center"}
                                                                                  style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"اولویت رشته"}
                                                                                    <TableSortLabel
                                                                                        active={orderBy === "fieldinsurance_priority"}
                                                                                        direction={
                                                                                              orderBy === "fieldinsurance_priority"
                                                                                                  ? order
                                                                                                  : "asc"
                                                                                        }
                                                                                        onClick={(e) => {
                                                                                              this.createSortHandler("fieldinsurance_priority")
                                                                                        }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>


                                                                              <TableCell
                                                                                    key={"fieldinsurance_badge"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" لیبل "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "fieldinsurance_badge"}
                                                                                          direction={
                                                                                                orderBy === "fieldinsurance_badge" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("fieldinsurance_badge")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>


                                                                              <TableCell
                                                                                    key={"fieldinsurance_perentlink"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" گروه بندی1 "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "fieldinsurance_perentlink"}
                                                                                          direction={
                                                                                                orderBy === "fieldinsurance_perentlink" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("fieldinsurance_perentlink")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>




                                                                              <TableCell
                                                                                    key={"fieldinsurance_mode"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                              >
                                                                                    {"وضعیت رشته"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "fieldinsurance_mode"}
                                                                                          direction={
                                                                                                orderBy === "fieldinsurance_mode" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("fieldinsurance_mode")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"fieldinsurance_deactive"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                              >
                                                                                    {"وضعیت رشته"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "fieldinsurance_deactive"}
                                                                                          direction={
                                                                                                orderBy === "fieldinsurance_deactive" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("fieldinsurance_deactive")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {agentInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["fieldinsurance_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell>
                                                                                                      <img
                                                                                                            className={classes.small}
                                                                                                            alt=""
                                                                                                            src={row["fieldinsurance_logo_url"]}
                                                                                                      />
                                                                                                </TableCell>
                                                                                                <TableCell key={"fieldinsurance_id"} align={"center"}>
                                                                                                      {row["fieldinsurance_id"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"fieldinsurance_fa"} align={"center"}>
                                                                                                      {row["fieldinsurance_fa"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"fieldinsurance_commission"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["fieldinsurance_commission"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                    key={"fieldinsurance_priority"}
                                                                                                    align={"center"}
                                                                                                >
                                                                                                      {row["fieldinsurance_priority"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"fieldinsurance_badge"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["fieldinsurance_badge"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"fieldinsurance_perentlink"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["fieldinsurance_perentlink"]}
                                                                                                </TableCell>



                                                                                                <TableCell
                                                                                                      key={"fieldinsurance_mode"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["fieldinsurance_mode"] === "1" ||
                                                                                                      row["fieldinsurance_mode"] === 1 ? (
                                                                                                            <Fab variant="extended">
                                                                                                                  <VoiceOverOffIcon />
                                                                                                                  {"آفلاین"}
                                                                                                            </Fab>
                                                                                                      ) : (
                                                                                                            <Fab
                                                                                                                  variant="extended"
                                                                                                                  style={{ background: "#44b700" }}
                                                                                                            >
                                                                                                                  <RecordVoiceOverIcon />
                                                                                                                  {"آنلاین"}
                                                                                                            </Fab>
                                                                                                      )}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"fieldinsurance_deactive"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["fieldinsurance_deactive"] === "1" ||
                                                                                                      row["fieldinsurance_deactive"] === 1 ? (
                                                                                                            <Fab variant="extended">
                                                                                                                  <VoiceOverOffIcon />
                                                                                                                  {"غیر فعال"}
                                                                                                            </Fab>
                                                                                                      ) : (
                                                                                                            <Fab
                                                                                                                  variant="extended"
                                                                                                                  style={{ background: "#44b700" }}
                                                                                                            >
                                                                                                                  <RecordVoiceOverIcon />
                                                                                                                  {"فعال"}
                                                                                                            </Fab>
                                                                                                      )}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100]}
                                                            component="div"
                                                            count={agentInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}

                              {this.state.openImageBox && (
                                    <Lightbox
                                          medium={urlToLargeImageFile}
                                          large={urlToHugeImageFile}
                                          alt={descImageFile}
                                          onClose={this.closeLightbox}
                                          showRotate={true}
                                          hideZoom={false}
                                    />
                              )}
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeFieldInsurance)
